// extracted by mini-css-extract-plugin
module.exports = {"container":"skeleton_container__TCr32","skeleton_animate":"skeleton_skeleton_animate__5s4uU"};